import {WithChildren} from '_metronic/helpers'
import {CSSProperties, FC} from 'react'
import {Modal} from 'react-bootstrap'
import Button from 'app/components/Button'

type Props = {
  isOpen: boolean
  onClose: () => void
  title: string
  cancelBtnText?: string
  okBtnText?: string
  okBtnType?: 'primary' | 'default' | 'transparent' | 'black'
  okBtnStyle?: CSSProperties
  cancelBtnClickHander?: () => void
  okBtnClickHandler?: () => void
  isCloseIconShown?: boolean
  isLoading?: boolean
  isLoadingBtnText?: string
  isOkBtnDisabled?: boolean
  dialogClassName?: string
}

const CustomModal: FC<Props & WithChildren> = ({
  isOpen,
  onClose,
  title,
  cancelBtnText,
  okBtnText,
  okBtnType,
  okBtnStyle,
  cancelBtnClickHander,
  okBtnClickHandler,
  isCloseIconShown,
  isLoading,
  isLoadingBtnText,
  isOkBtnDisabled,
  children,
  dialogClassName,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      backdropClassName='bg-opacity-1'
      dialogClassName={`${dialogClassName}`}
      // contentClassName='modal-rounded-lg'
      centered
    >
      <Modal.Header
        className='border-bottom border-gray-300'
        style={{
          // borderBottom: '1px solid #E5E7EB',
          // borderTopLeftRadius: '16px',
          // borderTopRightRadius: '16px',
          padding: '20px',
        }}
      >
        <Modal.Title className='tex-dark fw-bold fs-3'>{title}</Modal.Title>

        {isCloseIconShown && (
          <div className='d-flex ms-auto' style={{gap: '16px'}}>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary '
              onClick={onClose}
              aria-label='Close'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#5A5A5A'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-x'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M18 6l-12 12' />
                <path d='M6 6l12 12' />
              </svg>
            </div>
          </div>
        )}
      </Modal.Header>

      <Modal.Body
        className='bg-white'
        style={{
          borderBottomLeftRadius: `${!okBtnText ? 'var(--bs-modal-border-radius)' : ''}`,
          borderBottomRightRadius: `${!okBtnText ? 'var(--bs-modal-border-radius)' : ''}`,
          maxHeight: '60vh',
          overflowY: 'auto',
          padding: '20px',
        }}
      >
        {children}
      </Modal.Body>

      {okBtnText && (
        <Modal.Footer
          className='border-top border-gray-300 bg-white align-items-stretch'
          style={{
            gap: '6px',
            padding: '16px 20px',
          }}
        >
          {cancelBtnText && (
            <Button onClick={onClose}>
              {cancelBtnText}
            </Button>
          )}
          {isLoading ? (
            <Button btnType={okBtnType ?? 'primary'} disabled>
              <span>{isLoadingBtnText}</span>
              <span className='spinner-border spinner-border-sm align-middle mx-2'></span>
            </Button>
          ) : (
            <Button
              btnType={okBtnType ?? 'primary'}
              type='submit'
              onClick={okBtnClickHandler}
              disabled={isOkBtnDisabled}
            >
              {okBtnText}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  )
}

export {CustomModal}
